module.exports = __webpack_public_path__ + "static/media/21ECLAC23.ba9c5002.jpg";